if (!customElements.get('pp-pot-measurements')) {
  customElements.define('pp-pot-measurements', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.content = this.querySelector('[data-measurement-content]');
      this.dialog = this.querySelector('dialog');
      this.variants = new Map(Array.from(this.querySelectorAll('[data-variant]'), el => [el.dataset.variant, el.dataset.measurement]));
      this.templates = new Map(Array.from(this.querySelectorAll('[data-measurement-template]'), el => [el.dataset.measurementTemplate, el]));
      this.active = this.variants.get(this.dataset.variantId);
      document.addEventListener('variant:change', event => {
        const id = String(event.detail?.variant?.id ?? '');
        if (this.variants.has(id)) this.update(id);
      }, { ...options, capture: true });
      const bus = window.theme?.pubsub;
      if (bus) this.unsubscribe = bus.subscribe(bus.PUB_SUB_EVENTS.variantChange, event => {
        const data = event?.data;
        if (String(data?.productId) !== this.dataset.productId) return;
        this.update(String(data?.variant?.id ?? ''));
      });
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-enlarge]');
        if (link && this.dialog.showModal) {
          event.preventDefault();
          this.opener = link;
          const img = this.querySelector('[data-full-image]');
          img.src = link.href;
          img.alt = link.querySelector('img')?.alt || 'Produktmålstegning';
          this.dialog.showModal();
        }
        if (event.target.closest('[data-close]')) this.dialog.close();
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      }, options);
      this.dialog.addEventListener('close', () => this.opener?.isConnected && this.opener.focus(), options);
    }
    update(id) {
      const key = this.variants.get(id) || '';
      if (key === this.active) return;
      this.active = key;
      if (this.dialog.open) this.dialog.close();
      const template = this.templates.get(key) || this.querySelector('[data-measurement-empty]');
      this.content.replaceChildren(template.content.cloneNode(true));
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.unsubscribe?.();
    }
  });
}
